import administrationDashboardMoreComments from "~/store/graphql/queries/administrationDashboardMoreComments.graphql";

import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";

const loadAdminstrationMoreComments = async function (
  { commit },
  { params, req, res }
) {
  const data = await runGraphQLQuery(
    administrationDashboardMoreComments,
    params,
    this.$axios,
    req,
    res
  );

  commit("SET_ADMINISTRATION_MORE_COMMENTS", data);

  return Promise.resolve(data);
};

export default loadAdminstrationMoreComments;
